import moment from '../utils/momentWithLocale';

const DISPLAY_DATE_FORMAT = 'LLL';

const formatDate = (raw, forChart, formatOverride, showInLocalTime) => {
  let format, momentFunc;
  if (showInLocalTime) {
    momentFunc = moment;
  } else {
    momentFunc = moment.utc;
  }
  format = DISPLAY_DATE_FORMAT;
  if (!raw) {
    raw = 0;
  }
  if (forChart) {
    format = 'DD/MM';
  }
  if (formatOverride) {
    format = formatOverride;
  }
  return momentFunc(Number(raw)).format(format);
};

export default formatDate;
